export interface Config {
  endpoints: {
    status_api: string;
  };
  oidc: {
    authority: string;
    clientId: string;
    clientSecret: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    scope: string;
    responseType: string;
  };
  role: {
    siteAdmin: string;
  };
  telemetry: {
    enabled: boolean,
    appInsightsConnectionString: string,
  };
}

const scopes = "openid profile status:write";
const clientId = "hcss-status-ui";

const devAPI = "https://dev-status.hcssapps.com";

const prodHcssAppsApi = "https://status.hcssapps.com";

const devAdminRole = "HCSS ADMIN";
const prodAdminRole = "HCSS ADMIN";

const local: Config = {
  endpoints: {
    status_api: "https://localhost:5001",
  },
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: "https://localhost:5001/oidc/signin-callback",
    postLogoutRedirectUri: "https://localhost:5001/",
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: devAdminRole,
  },
  telemetry: {
    enabled: false,
    appInsightsConnectionString: "InstrumentationKey=c2236307-fcd3-44e9-ac28-b1f6ebf1bf50;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=df3a9442-e18d-4bc5-bd7a-1f6a239e53c0",
  },
};

const dev: Config = {
  endpoints: {
    status_api: devAPI,
  },
  oidc: {
    authority: "https://dev-identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${devAPI}/oidc/signin-callback`,
    postLogoutRedirectUri: `${devAPI}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: devAdminRole,
  },
  telemetry: {
    enabled: false,
    appInsightsConnectionString: "InstrumentationKey=c2236307-fcd3-44e9-ac28-b1f6ebf1bf50;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=df3a9442-e18d-4bc5-bd7a-1f6a239e53c0",
  },
};

const production: Config = {
  endpoints: {
    status_api: prodHcssAppsApi,
  },
  oidc: {
    authority: "https://identity.hcssapps.com",
    clientId: clientId,
    clientSecret: "dummy",
    redirectUri: `${prodHcssAppsApi}/oidc/signin-callback`,
    postLogoutRedirectUri: `${prodHcssAppsApi}/`,
    responseType: "code",
    scope: scopes,
  },
  role: {
    siteAdmin: prodAdminRole,
  },
  telemetry: {
    enabled: true,
    appInsightsConnectionString: "InstrumentationKey=bcc8dcd4-2433-49ce-87eb-47caaa30617d;IngestionEndpoint=https://eastus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=ff48b367-99d7-4524-a2eb-06927d77ddf6",
  },
};

export const GetEnvironmentConfig = () => {
  const hostname = window.location.hostname.toLowerCase();
  const origin = window.location.origin.toLowerCase();
  if (hostname.includes("localhost")) return local;
  if (hostname.includes("dev-status")) return dev;
  if (hostname.includes("dev-hcss-status")) return dev;
  if (hostname.includes("hcssstatusdev")) return dev;
  if (origin.includes("https://dev-status.hcssapps.com")) return dev;
  if (origin.includes("https://status.hcssapps.com")) return production;
  if (origin.includes("https://status.hcss.com")) return production;
  if (hostname.includes("hcssstatusprod")) return production;
  return production;
};
